import { render, staticRenderFns } from "./AddBan.vue?vue&type=template&id=f9262a30&"
import script from "./AddBan.vue?vue&type=script&lang=js&"
export * from "./AddBan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports